export const getRows = (gridList, data, contextName, table, type) => {
  let rows = [];
  // console.log(data, contextName)
  switch (gridList.gridPage) {
    case "screens":
      rows = data[contextName]?.filter(
        (screen) =>
          !screen.hasOwnProperty("list_variant") || screen.list_variant === 0
      );
      break;
    case "analysisCategory":
      rows = data[contextName]
        ?.filter(
          (cat) =>
            cat.analysisCategory_number !== "0" &&
            cat.analysisCategory_number !== "100"
        )
        .sort((a, b) => a[type] - b[type]);

      break;
    case "pricebands":
      rows = data[contextName]
        ?.filter((cat) => cat.priceband_number !== "1")
        .sort((a, b) => a[type] - b[type]);

      break;
    case "staff":
      rows = data[contextName]
        ?.filter((i) => i.server_number !== "419" && i.server_number !== 419)
        .sort((a, b) => a[type] - b[type]);
      break;
    default:
      rows = data[contextName];
  }
  return rows?.filter((i) => i[`${table}_isDeleted`] === 0);
};

export const getAllRows = (gridList, data, contextName, table, type) => {
  let rows;
  switch (gridList.gridPage) {
    case "screens":
      rows = data[contextName]?.filter(
        (screen) =>
          !screen.hasOwnProperty("list_variant") || screen.list_variant === 0
      );
      break;
    case "analysisCategory":
      rows = data[contextName]
        ?.filter(
          (cat) =>
            cat.analysisCategory_number !== "0" &&
            cat.analysisCategory_number !== "100"
        )
        .sort((a, b) => a[type] - b[type]);

      break;
    case "pricebands":
      rows = data[contextName]
        ?.filter((cat) => cat.priceband_number !== "1")
        .sort((a, b) => a[type] - b[type])
        .filter((i) => i[`${table}_isDeleted`] === 0);

      break;
    case "staff":
      rows = data[contextName]
        ?.filter((i) => i.server_number !== "419" && i.server_number !== 419)
        .sort((a, b) => a[type] - b[type]);
      break;
    default:
      rows = data[contextName];
  }
  return rows;
};

function round50(x, increment, direction) {
  if (direction === "up") {
    return Math.ceil(x / increment) * increment;
  } else return Math.floor(x / increment) * increment;
}

export const getUpdatedDisplayPrice = (
  rows,
  unsavedChangesRef,
  num,
  watchPercentage,
  watchFixedAmount,
  percentAmount,
  increaseDecrease,
  fixedAmount,
  watchRound,
  roundTo,
  roundDirection
) => {
  if (num) {
    const oldRow = unsavedChangesRef.current.unsavedRows[num]
      ? unsavedChangesRef.current.unsavedRows[num]
      : rows?.find((row) => parseInt(row?.uid) === parseInt(num));
    if (oldRow) {
      const row = { ...oldRow };
      //   console.log("orig price", row?.plu_details?.price);
      let price = parseFloat(row?.plu_details?.price);
      const addAmount = parseFloat(fixedAmount.toFixed(2));
      //   console.log("price", price);
      //   console.log("add amount", addAmount);
      const percent = parseFloat(percentAmount) / 100;
      const inc = price * percent;
      //   console.log("percent", percent);
      //   console.log("fixed amont", fixedAmount);
      //   console.log("price * percent", price * percent);
      //   console.log("price + inc", price + inc);
      if (watchPercentage && watchFixedAmount) {
        if (increaseDecrease === "increase") {
          console.log("here increase");
          price = price + inc + addAmount;
        } else {
          price = price - inc - addAmount;
        }
      }
      if (!watchPercentage && watchFixedAmount) {
        if (increaseDecrease === "increase") {
          price = price + addAmount;
        } else {
          price = price - addAmount;
        }
      }
      if (watchPercentage && !watchFixedAmount) {
        console.log("here 2", isNaN(percentAmount));

        if (increaseDecrease === "increase") {
          price = price + inc;
        } else {
          price = price - inc;
        }
      }

      if (watchRound === true) {
        price = round50(price, roundTo, roundDirection);
      }
      const obj = {
        old: row?.plu_details?.price,
        new: price >= 0 ? price : 0,
        difference:
          price >= 0
            ? price - row?.plu_details?.price
            : (row?.plu_details?.price - 0) * -1,
        plu_name: row?.plu_name,
      };
      return obj;
    }
  }
};

export const getUpdatedModPrice = (
  oldPrice,
  watchPercentage,
  watchFixedAmount,
  percentAmount,
  increaseDecrease,
  fixedAmount,
  watchRound,
  roundTo,
  roundDirection
) => {
  let price = parseFloat(oldPrice);
  const addAmount = parseFloat(fixedAmount.toFixed(2));

  const percent = parseFloat(percentAmount) / 100;
  const inc = price * percent;

  //   let price = oldPrice;
  if (watchPercentage && watchFixedAmount) {
    if (increaseDecrease === "increase") {
      price = price + inc + addAmount;
    } else {
      price = price - inc - addAmount;
    }
  }
  if (!watchPercentage && watchFixedAmount) {
    if (increaseDecrease === "increase") {
      price = price + addAmount;
    } else {
      price = price - addAmount;
    }
  }
  if (watchPercentage && !watchFixedAmount) {
    if (increaseDecrease === "increase") {
      price = price + inc;
    } else {
      price = price - inc;
    }
  }

  if (watchRound === true) {
    price = round50(price, roundTo, roundDirection);
  }
  if (isNaN(price)) {
    return 0;
  } else return price >= 0 ? price.toFixed(2) : 0;
};
